import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';
import Preloader from '../Preloader/Preloader';

class CustomDropdownPracticeTags extends Component {
  static defaltProps = {
    label: 'Текущий раздел:'
  };

  static propTypes = {
    categories: PropTypes.array.isRequired,
    selectedCategories: PropTypes.array.isRequired,
    label: PropTypes.string,
    headerTitle: PropTypes.string,
    isLoadingSelectedTags: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.dropdownItem = React.createRef();
    this.dropdownList = React.createRef();
    this.state = {
      listOpened: false
    };
  }

  componentDidMount() {
    const height = document.documentElement.clientHeight - this.dropdownItem.current.getBoundingClientRect().top - 62;
    this.dropdownList.current.style.maxHeight = height + 'px';
  }

  openItem = (alias) => {
    if (this.props.selectedCategories.indexOf(alias) == -1) {
      const selected = [...this.props.selectedCategories, alias];
      this.setState(
        {
          listOpened: true
        },
        () => this.props.onChange(selected)
      );
    }
  };

  closeItem = (alias) => {
    const selected = this.props.selectedCategories.filter(x => x !== alias);
    this.setState(
      {
        listOpened: true
      },
      () => this.props.onChange(selected)
    );
  };

  toggleList = () => {
    this.setState(prevState => ({
      listOpened: !prevState.listOpened
    }));
  };

  handleClickOutside(e) {
    this.setState({
      listOpened: false
    });
  }

  isActive = alias => this.props.selectedCategories.indexOf(alias) > -1;

  render() {
    const { listOpened } = this.state;
    const { categories, selectedCategories, isLoadingSelectedTags } = this.props;
    if (!categories || !selectedCategories) return <Preloader />;
    return (
      <div
        className={classnames('custom-dropdown -type2', {
          active: listOpened
        })}
      >
        <div className="custom-dropdown__selected" onClick={this.toggleList} ref={this.dropdownItem}>
          <div className="custom-dropdown__selected-wrapper">
            {`Выбрано тегов: ${selectedCategories.length}`}
          </div>
        </div>
        <ul className="custom-dropdown__list">
          <li className="custom-dropdown__item -content" ref={this.dropdownList}>
            {isLoadingSelectedTags ? <Preloader/> : <></>}
            <div className="tags">
              {categories.length ? (
                categories.map(item => (
                  <span
                    key={item.id}
                    className={classnames('tags-item', { '-active': this.isActive(item.alias) })}
                    tabIndex="0"
                    onClick={() => this.openItem(item.alias)}
                  >
                    {item.tag}
                    {this.isActive(item.alias) && (
                      <button
                        className="tags-item-deactivate"
                        onClick={() => this.closeItem(item.alias)}
                      >
                        {'Отменить'}
                      </button>
                    )}
                  </span>
                ))
              ) : (
                <li>
                  <Preloader />
                </li>
              )}
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default onClickOutside(CustomDropdownPracticeTags);
